'use strict';

var randomString = require('./random_string');

/**
 * Create a generator instance.
 */
function SequenceIdGenerator() {
  this.reset();
}

/**
 * Create a generator instance.
 * @return {SequenceIdGenerator} A sequence_id and sequence_number generator
 *     instance.
 */
SequenceIdGenerator.create = function() {
  return new SequenceIdGenerator();
};

/**
 * Reset the state and generate a new sequence_id.
 */
SequenceIdGenerator.prototype.reset = function() {
  this._sequenceId = randomString.generateBase64(16);
  this._sequenceNumbers = {};
};

/**
 * Get the latest sequence_id.
 * @return {string} The sequence_id used to identify event messages.
 */
SequenceIdGenerator.prototype.getSequenceId = function() {
  return this._sequenceId;
};

/**
 * Generate the next sequence_number to identify event messages.
 * @param {string} eventName The name of the event to generate a sequence_number
       for.
 * @return {number} Incremental number starting from 1.
 */
SequenceIdGenerator.prototype.nextSequenceNumber = function(eventName) {
  if (!this._sequenceNumbers[eventName]) {
    this._sequenceNumbers[eventName] = 0;
  }
  return ++this._sequenceNumbers[eventName];
};

module.exports = SequenceIdGenerator;
